// import logo from './logo.svg';
// import './App.css';

import KalenderJawa from '../kalenderjawa/KalenderJawa';

function App() {

  return (
    <div className="App">
        <KalenderJawa />
    </div>
  );
}

export default App;
